import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=49738a8b&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=49738a8b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49738a8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49738a8b')) {
      api.createRecord('49738a8b', component.options)
    } else {
      api.reload('49738a8b', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=49738a8b&scoped=true", function () {
      api.rerender('49738a8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/visit/Create.vue"
export default component.exports